export default __webpack_public_path__ + "static/media/background.a7a346ac.png";